import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Users.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import { ToggleButton } from 'primereact/togglebutton';
import { Password } from 'primereact/password';
import ConfBar from '../ConfBar/ConfBar';
import Video from '../Video/Video';
import { Divider } from 'primereact/divider';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileUpload } from 'primereact/fileupload';
import { saveAs } from 'file-saver';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Users
Description : Pagina de Users para el CRUD de los usuarios del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
================================================================================ */
export default function Users() {
  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const [number_id, setNumber_id] = useState("");
  const [status, setStatus] = useState("");
  const [user_name, setUser_name] = useState("");
  const [password, setPassword] = useState("");
  const setOptions_edit = []
  const [updateNumber_id, setUpdateNumber_id] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [updateUser_name, setUpdateUser_name] = useState("");
  const [updatePassword, setUpdatePassword] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [listaStatus, setListaStatus] = useState([]);
  const [user_id, setUser_id] = useState("");
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenUsers, setIsOpenUsers] = React.useState(false);
  const [checked1, setChecked1] = useState(false);
  const [rowData, setRowData] = useState([]);
  const headers = {
    authorization: localStorage.getItem('token')
  }
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem" }
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [consultado, setConsultado] = useState(false)

  useEffect(() => {
    const getLists = async () => {
      await apis.getUsersList(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
        let codsEmpleados = res.data["CONTRACTS"]
        let contenidoCodEmpleado = []
        let statusData = res.data["STATUS"]
        let contenidoStatus = []

        codsEmpleados.forEach(element => {
          contenidoCodEmpleado.push({ "value": '' + element.NAME.split('|')[0].trim() + '', "label": '' + element.NAME + '' });
        })
        setListaCodEmpleado(contenidoCodEmpleado);

        statusData.forEach(element => {
          contenidoStatus.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
        })
        setListaStatus(contenidoStatus);
        setStatus(contenidoStatus[0])
      })
      setTabla()
    }
    getLists()
  }, []);



  const showModal = () => {
    setIsOpen(true);
  };

  const hideModal = () => {
    limpiar();
    setIsOpen(false);
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
  };

  const showModalEliminar = (USERID) => {
    setDeleteId(USERID);
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalUsers = () => {
    setIsOpenUsers(true);
  };

  const hideModalUsers = () => {
    setIsOpenUsers(false)
  };


  function inizilaizarData(rowData) {
    setOptions_edit.push({ "value": '' + rowData.STATUS_CODE + '', "label": '' + rowData.STATUS + '' });
    setUpdateNumber_id(rowData.NUMBER_ID)
    setUpdateUser_name(rowData.USERNAME)
    setUser_id(rowData.USERID)
    setUpdateStatus(setOptions_edit[0])
    showModal_();
  }

  async function limpiar() {
    setNumber_id("");
    setUser_name("");
    setPassword("");
  }

  function validar() {
    if (number_id == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Codigo del empleado', life: 4000 });
      return false
    } if (status.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar estado', life: 4000 });
      return false
    } if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user_name)) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar correo valido', life: 4000 });
      return false
    }
    // if (password == "") {
    //   toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar contraseña', life: 4000 });
    //   return false
    // }
    return true
  }

  async function setTabla() {
    await apis.getUsers(localStorage.getItem("entity"), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["USERS"].length > 0) {
        let data = res.data["USERS"]
        let contenidoTabla = []
        data.forEach(element => {
          let status = element["STATUS"].split("|")
          let datos = element["NUMBER_ID"].split("|")
          contenidoTabla.push({ USERID: element.USERID, CONTRACT_ID: datos[0], NUMBER_ID: datos[1].trim(), NAME: datos[2].trim(), STATUS_CODE: status[0], STATUS: status[1], USERNAME: element.USERNAME })
        })
        setRowData(contenidoTabla)
        setLoadPage(true)
      } else {
        setRowData([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  async function completarRegistro() {

    if (validar()) {
      setLoadingCreate(true)

      const _number_id = number_id.value;
      const _user_name = user_name;
      // const _password = password;
      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')
      const _status = status.value;

      const user = {
        CLIENT: _cliente,
        ENTITY: _entity,
        USERNAME: _user_name,
        // PASSWORD: _password,
        STATUS: _status,
        ROLEID: '7',
        NUMBER_ID: _number_id
      }

      await apis.postUsers(user, headers).then(res => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Usuario agregado exitosamente', life: 4000 });
        hideModal();
        setTabla();
        limpiar();
      }).catch(err => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  async function actualizar() {

    setLoadingUpdate(true)

    const _user_id = user_id;
    const _number_id = updateNumber_id;
    const _status = updateStatus.value;
    const _user_name = updateUser_name;
    const _password = updatePassword;
    const _client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    let user = null;
    console.log(checked1)
    if (checked1) {
      if (_password == '' || _password == null || _password == undefined) {
        setLoadingUpdate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar contraseña', life: 4000 });
      } else {
        user = {
          CLIENT: _client,
          ENTITY: _entity,
          USERNAME: _user_name,
          PASSWORD: _password,
          STATUS: _status,
          ROLEID: '7',
          NUMBER_ID: _number_id,
          USERID: _user_id
        }
      }
    } else {
      user = {
        CLIENT: _client,
        ENTITY: _entity,
        USERNAME: _user_name,
        PASSWORD: 'NULL',
        STATUS: _status,
        ROLEID: '7',
        NUMBER_ID: _number_id,
        USERID: _user_id
      }
    }

    if (user) {
      await apis.putUsers(user, headers).then(res => {
        setLoadingUpdate(false)
        setIsOpen_(false);
        setTabla();
        setUpdatePassword("")
        setChecked1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
      }).catch(err => {
        setLoadingUpdate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })

    }
  }

  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _userid = deleteId;
    await apis.deleteUsers(_entity, _cliente, _userid, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Usuario eliminado', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }

  async function downloadSampleFileUsers() {
    let payload = {
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.importUsers(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading1(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading1(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importDataUsers(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.importUsers(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importUsers(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importDataUsers(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
        <Button label="Cargar usuarios" icon="pi pi-users" className="p-button-success mr-2 p-button-sm "
          tooltip='Proceso cargue masivo usuarios' tooltipOptions={{ position: 'top' }}
          onClick={() => showModalUsers()}
        />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" onClick={() => { showModalEliminar(rowData.USERID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }




  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'USERNAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} loading={loadingCreate} label='Guardar'></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar Usuario</h3>
    </div>
  );

  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} loading={loadingUpdate} label='Guardar'></Button>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar Usuario</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} loading={loadingDelete} label='Si'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el usuario?</h3>
    </div>
  );

  const passwordFooter = (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', textAlign: 'left' }}>
      <Divider />
      <p className="mt-2">Sugerencias</p>
      <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
        <li>Al menos una mayúscula</li>
        <li>Al menos una minúscula</li>
        <li>Al menos un número</li>
        <li>Al menos uno de estos carácteres (* . ! $ _)</li>
        <li>Mínimo 8 caracteres</li>
      </ul>
    </div>
  );




  const passwordHeader = <h6>Su contraseña es:</h6>;

  const updateBody = (

    <div>
      <LabelField htmlFor="label">Correo</LabelField>
      <InputText style={{ width: "20rem" }} className='mb-2' value={updateUser_name} type="email" onChange={(e) => setUpdateUser_name(e.target.value)} placeholder="correo" />
      <LabelField htmlFor="label">¿Cambiar contraseña?</LabelField>
      <ToggleButton className="p-button-sm text-xs mb-1" onLabel="Si" checked={checked1} onChange={(e) => setChecked1(e.value)} onIcon="pi pi-check" offIcon="pi pi-times" />
      {checked1 ?
        <Password id="password" name="password" value={updatePassword} onChange={(e) => setUpdatePassword(e.target.value)} style={{ width: "20rem" }}
          toggleMask header={passwordHeader} footer={passwordFooter}
          mediumRegex={"^(((?=.*[!*.$_])(?=.*[A-Z]))|((?=.*[!*.$_])(?=.*[0-9]))|((?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
          strongRegex={"^(?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
          weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" />
        : null}

      <LabelField htmlFor="label">Estado</LabelField>
      <Dropdown style={elementWidth} value={updateStatus.value} options={listaStatus} onChange={setUpdateStatus} placeholder={updateStatus.label} />

    </div>
  );

  const footerUsers = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading1(false); setLoading2(false); hideModalUsers() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading1} onClick={() => { setLoading1(true); downloadSampleFileUsers() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importUsers}>
      </FileUpload>
    </div>
  );

  const headerUsers = (
    <div>
      <h3>Cargar usuarios</h3>
    </div>
  )

  return (

    <div className='mt-6'>
      <Toast ref={toast} />

      <div className="pt-5">
        <ConfBar />
      </div>


      <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
        <span className="text-900">Usuarios Autogestión</span>
        <Video header="Instructivo procesos usuarios y autogestión" url={localStorage.getItem('USERS_VIDEO')} />
      </div>

      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Código empleado</LabelField>
          <Dropdown style={elementWidth} value={number_id.value} options={listaCodEmpleado} placeholder={"Seleccione un usuario"} onChange={setNumber_id} />
          <LabelField htmlFor="label">Correo</LabelField>
          <InputText style={{ width: "20rem" }} value={user_name} type="email" onChange={(e) => setUser_name(e.target.value)} placeholder="correo" />
          {/* <InputText  style={{ width: "20rem"}} value={updateUser_name} type="email" onChange={(e) => setUser_name(e.target.value)} placeholder="correo"/> */}
          {/* <LabelField htmlFor="label">Contraseña</LabelField> */}

          {/* <Password id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: "20rem" }}
            toggleMask header={passwordHeader} footer={passwordFooter}
            mediumRegex={"^(((?=.*[!*.$_])(?=.*[A-Z]))|((?=.*[!*.$_])(?=.*[0-9]))|((?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
            strongRegex={"^(?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
            weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" /> */}

          <LabelField htmlFor="label">Estado</LabelField>
          <Dropdown style={elementWidth} value={status.value} options={listaStatus} onChange={setStatus} />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_} >
          {updateBody}
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={headerUsers} footer={footerUsers} visible={isOpenUsers}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalUsers}>
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja UploadUsers con la información de los usuarios de autogestión.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} />
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="USERID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'USERNAME', 'STATUS']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="USERNAME" header="Nombre de usuario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre de usuario" sortable></Column>
              <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}